import React, { Component } from 'react'
import { onChange, validateForm } from '../../utils';
import PreviewLetter from '../../Component/GenerateOfferLetter/preview';
import Form from '../../Component/GenerateOfferLetter/form';

import Swal from 'sweetalert2'
import { loiformdata, onSendOfferLetter } from '../../action/loiAction';
import { withRouter } from 'react-router-dom';
import queryString from 'query-string';
import moment from 'moment';
import constant from '../../constant';
class LOI extends Component {
    constructor(props) {
        super(props);
        this.state = {
            Preview: false,
            model: {
                CandidateName: '',
                DateOfJoining: '',
                ctc: '',
                Designation: '',
                NoticePeriod: '',
                MedicalInsurance: '',
                AccidentalInsurance: '',
                Address: '',
                City: '',
                State: '',
                PinCode: ''
            }
        }
    }


    componentDidMount() {

        // this.props.location.search
        //  this.props.location.search);
        const qParam = queryString.parse(this.props?.location?.search)
        loiformdata(qParam).then(res => {
            if (res.status) {
                const { CandidateName, DateOfJoining, ctc, NoticePeriod, MedicalInsurance, AccidentalInsurance, Designation } = this.state
                onChange(this, CandidateName.name, res?.result?.CANDIDATE_NAME ? res?.result?.CANDIDATE_NAME : '')
                onChange(this, DateOfJoining.name, res?.result?.DOJ ? res?.result?.DOJ : '')
                onChange(this, ctc.name, res?.result?.CTC ? res?.result?.CTC : '')
                onChange(this, Designation.name, res?.result?.DESIGNATION ? res?.result?.DESIGNATION : '')
                onChange(this, NoticePeriod.name, res?.result?.NOTICE_PERIOD ? res?.result?.NOTICE_PERIOD : '')
                onChange(this, MedicalInsurance.name, res?.result?.MEDICLAIM ? res?.result?.MEDICLAIM : '')
                onChange(this, AccidentalInsurance.name, res?.result?.ACCIDENTAL_INSURANCE ? res?.result?.ACCIDENTAL_INSURANCE : '')
                this.setState({ CREATED_ON: res?.result?.CREATED_ON ? res?.result?.CREATED_ON : moment() })
                this.setState({
                    Address: res.result.ADDRESS,
                    City: res.result.CITY,
                    State: res.result.STATE,
                    PinCode: res.result.PIN_CODE,
                    CompanyLogo: res.result.COMPANY_LOGO,
                    CompanyName: res.result.COMPANY_NAME
                })
            }
        })


    }

    onChange = (e) => {
        const { name, value } = e.target;
        onChange(this, name, value)
    }
    onSubmit = (model) => {
        this.setState({ model: model, Preview: true })
    }

    onSend = () => {
        const { DateOfJoining, ctc, NoticePeriod, MedicalInsurance, AccidentalInsurance, Designation } = this.state.model
        const qParam = queryString.parse(this.props?.location?.search)
        const model = {
            CANDIDATE_ID: qParam.cid,
            CAMPUS_STUDENT_ID: qParam.sid,
            JOB_ID: qParam.jid,
            DOJ: DateOfJoining,
            CTC: ctc,
            DESIGNATION: Designation,
            NOTICE_PERIOD: NoticePeriod,
            MEDICLAIM: MedicalInsurance,
            ACCIDENTAL_INSURANCE: AccidentalInsurance,
            APPLICATION_ID:qParam.aid,
            source:qParam.source,

        }
        let sending = true
        {
            sending && Swal.fire({
                html: 'Sending....',
                didOpen: () => {
                    Swal.showLoading()
                }
            })
        }
        onSendOfferLetter(model).then((res) => {

            if (res.status) {
                sending = false
                Swal.fire({
                    text: res.result.message,
                    icon: 'success'
                }).then(res => {
                    this.props.history.push(constant.component.dashboard.url)
                })
            }
            else {
                Swal.fire({
                    text: res.result.error,
                    icon: 'error'
                })
            }
        })
    }
    render() {
        const { model, Preview, } = this.state
        return (
            <React.Fragment>
                <div className="container-fluid">
                    <div className='row'>
                        <div className='col-md-12'>
                            <section className='my-1'>
                                <div className='container'>
                                    <div className='row'>
                                        <div className='col-md-12'>
                                            <nav aria-label="breadcrumb">
                                                <ol className="breadcrumb">
                                                    <li className="breadcrumb-item"><a href="/">Home</a></li>
                                                    <li className="breadcrumb-item"><a href={constant.component.dashboard.url}>Jobs</a></li>
                                                    <li className="breadcrumb-item active" aria-current="page">Applications</li>
                                                </ol>
                                            </nav>
                                        </div>
                                    </div>
                                </div>
                                {
                                    <div className='row'>
                                        <div className='col-md-12'>
                                            {
                                                Preview && <PreviewLetter
                                                    model={model}
                                                    onSend={() => { this.onSend() }}
                                                    onEdit={() => { this.setState({ Preview: false }) }}
                                                />
                                            }
                                            {!Preview &&
                                                <Form
                                                    onSubmit={(e) => (this.onSubmit(e))}
                                                />

                                            }

                                        </div>
                                    </div>
                                }
                            </section>

                        </div>
                    </div>
                </div>

            </React.Fragment>

        )
    }
}
export default withRouter(LOI)
